import { BackNavigationContext, PageTitleContext } from '@/lib/backNavigation'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useContext, type ComponentProps } from 'react'

export function BackNavigationLink({
  onClick,
  ...props
}: ComponentProps<typeof Link>) {
  const pageTitle = useContext(PageTitleContext)
  const { asPath } = useRouter()
  const [, setPrevPage] = useContext(BackNavigationContext)

  return (
    <Link
      {...props}
      onClick={(event) => {
        if (pageTitle) {
          const targetPathname =
            event.currentTarget.pathname +
            event.currentTarget.search +
            event.currentTarget.hash
          setPrevPage({
            on: targetPathname,
            title: pageTitle,
            href: asPath,
          })
        }
      }}
    />
  )
}
